module.exports = {"title":"Login","properties":[{"label":"username","type":"text","placeholder":"username","name":"username","required":true,"value":""},{"label":"password","type":"password","name":"password","value":"","required":true,"placeholder":"password"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/_data/login.json
// module id = 74
// module chunks = 0